/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'pip-events'
],
function homeServicesCoordinator(
    $,
    pip,
    pipEvents
){
    var NOT_DISPLAYED = 'notDisplayed';
    var KITCHEN_CABINETS_GUID = 'c07de5b6-4f80-4dda-972e-33c2400309a6'; 
    var model = {
        constants: {
            ASSEMBLY_SERVICE_TYPE: 'Assembly',
            INSTALL_SERVICE_TYPE: 'Install'
        },
        getData: function getData(){
            var show = '&show=doitforme,doityourself';
            var params = {
                installSkus: pip.serviceAddOns.attachLabor.installationSku,
                itemId: pip.products.primary.data.itemId,
                storeId: pip.customer.localStore.storenumber,
                key: 'tmUwNSh4jVZ4YzcMSlEM9xFGADJJx291'
            }
            var url = '/installSkuInfo/v1?' + $.param(params, true) + show;
                        
            return $.ajax({
                type: "GET",
                url: url,
            })
        },
        isInstallationSkuAvailable: function isInstallationSkuAvailable(data) {
            return !!(data
                && data.installSkus
                && data.installSkus[0]
                && data.installSkus[0].installRetailPrice
                && data.installSkus[0].installRetailPrice.price
                && data.installSkus[0].eligibility
                && !data.installSkus[0].eligibility.errorCode
                && data.installSkus[0].eligibility.isInstallAvailable
                &&  (viewModel.isSellableAssemblyDisplayable(data) || viewModel.isSellableInstallationDisplayable(data)))
        }
    }
    var viewModel = {
        isSellableAssemblyDisplayable: function(data) {
            return (data.installSkus[0].serviceType === model.constants.ASSEMBLY_SERVICE_TYPE)
        },
        isSellableInstallationDisplayable: function(data) {
            return (data.installSkus[0].serviceType === model.constants.INSTALL_SERVICE_TYPE)
        }
    }

    function setIsCustomKitchenCabinetsFlag() {
        var isCustomKitchenCabinets;
        var notDisplayedAttributeGroup = pip.products.primary.data.attributeGroups.filter(function (attrs) {
            return attrs.groupType === NOT_DISPLAYED;
        })[0];

        if (notDisplayedAttributeGroup) {
            isCustomKitchenCabinets = !!(notDisplayedAttributeGroup.entries.filter(function (entry) {
                return entry.value === KITCHEN_CABINETS_GUID;
            }).length);
        }
        pip.setFlag('isCustomKitchenCabinets', isCustomKitchenCabinets);
    }

    return {
        init: function init() {
            setIsCustomKitchenCabinetsFlag();
            pip.installationSku = null;   
            var homeServicesAddOnAvailability = {
                isAvailable: false
            };

            if (!this.shouldCallService()) {
                pipEvents.pipLifecycleEvents.attachLabor.attachLaborProcessed.trigger(homeServicesAddOnAvailability);
                return;
            }

            model.getData().done(function(data) {         
                if (model.isInstallationSkuAvailable(data)) {
                    pip.installationSku = data.installSkus[0];
                    pip.installationSku.doItYourself = data.doItYourself && data.doItYourself[0];
                    homeServicesAddOnAvailability.isAvailable = true;
                    pip.installationSku.isInstall = viewModel.isSellableInstallationDisplayable(data);
                    pip.installationSku.isAssembly = viewModel.isSellableAssemblyDisplayable(data);
                }
            }).fail(function(e) {
                if (pip.debugMode) {
                    console.error('Failed to load home services model:', e);
                }
            }).always(function() {
                pipEvents.pipLifecycleEvents.attachLabor.attachLaborProcessed.trigger(homeServicesAddOnAvailability);
            });
        },
        model: model,
        viewModel: viewModel,
        shouldCallService: function shouldCallService() {
            return !!(pip.features
                && pip.features.attachLaborFeatureEnabled
                && !pip.isB2BCustomer
                && pip.fulfillment
                && pip.fulfillment.shipping
                && pip.fulfillment.shipping.shipToHome
                && pip.serviceAddOns
                && pip.serviceAddOns.attachLabor
                && pip.serviceAddOns.attachLabor.installationSku)
        },
        setIsCustomKitchenCabinetsFlag: setIsCustomKitchenCabinetsFlag
    }
});
}.call(window));